// extracted by mini-css-extract-plugin
module.exports = {"header":"ListArea_header__CKsv1","container":"ListArea_container__1Q-8P","items":"ListArea_items__2xcU6"};